import { TFunction } from "i18next";
import { IPropsInputField } from "./fieldPropertiesInterface";
import { useModel } from "../../contexts/modelContext";
import modelHelper from "./modelHelper";
import { useRef, useState } from "react";
import { withTranslation } from "react-i18next";

interface IPropsType {
  t: TFunction;
  prefix?: React.ReactElement;
  sufix?: React.ReactElement;
}

type IPropsAuthenticatorField = IPropsInputField & IPropsType;

function AuthenticatorCodeField({
  model,
  attr,
  value,
  onChange,
  disabled,
  required,
  autoFocus,
  prefix,
  sufix,
  t
}: IPropsAuthenticatorField) {
  const modelContext = useModel();
  const modelState = model || modelContext;
  const { onValueChange, getValue } = modelHelper({ model: modelState, attr, value, onChange });

  const [code, setCode] = useState(new Array(6).fill(""));
  const inputsRef = useRef<Array<HTMLInputElement | null>>([]);

  const handleChange = (val: string, index: number) => {
    if (/^\d$/.test(val)) {
      const newCode = [...code];
      newCode[index] = val;
      setCode(newCode);

      const input = document.createElement("input");
      input.value = newCode.join("");

      const syntheticEvent = {
        target: input,
      } as React.ChangeEvent<HTMLInputElement & HTMLSelectElement & HTMLTextAreaElement>;

      onValueChange(syntheticEvent);

      if (index < 5) {
        inputsRef.current[index + 1]?.focus();
      }
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent, index: number) => {
    if (e.key === "Backspace") {
      e.preventDefault();
      const newCode = [...code];
      if (code[index]) {
        newCode[index] = "";
        setCode(newCode);
        // Actualizar el valor global
        const input = document.createElement("input");
        input.value = newCode.join("");
        const syntheticEvent = {
          target: input,
        } as React.ChangeEvent<HTMLInputElement & HTMLSelectElement & HTMLTextAreaElement>;
        onValueChange(syntheticEvent);
      } else if (index > 0) {
        newCode[index - 1] = "";
        setCode(newCode);
        // Actualizar el valor global
        const input = document.createElement("input");
        input.value = newCode.join("");
        const syntheticEvent = {
          target: input,
        } as React.ChangeEvent<HTMLInputElement & HTMLSelectElement & HTMLTextAreaElement>;
        onValueChange(syntheticEvent);
        inputsRef.current[index - 1]?.focus();
      }
    }
  };

  return (
    <div className="auth-code-input-group">
      {prefix && <span className="prefix">{prefix}</span>}
      {code.map((digit, index) => (
        <input
          key={index}
          type="text"
          maxLength={1}
          value={digit}
          onChange={(e) => handleChange(e.target.value, index)}
          onKeyDown={(e) => handleKeyDown(e, index)}
          ref={(el) => (inputsRef.current[index] = el)}
          disabled={disabled}
          autoFocus={autoFocus && index === 0}
          className={`auth-code-digit h-40 w-15 ${(index > 0 && 'ms-1')} ${index === 2 && 'me-1'}`}
          style={{height: "2rem", borderRadius: "9px", lineHeight: "24px", textAlign: "center", border: "1px solid grey"}}
        />
      ))}
      {sufix && <span className="sufix">{sufix}</span>}
    </div>
  );
}

export default withTranslation()(AuthenticatorCodeField);
